import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-get-visits',
  templateUrl: './get-visits.component.html',
  styleUrls: ['./get-visits.component.scss']
})
export class GetVisitsComponent implements OnInit {

  moment: any = moment;
  visits: any = [];
  id: any;

  constructor(
    private config: ApiConfiguration, 
    private service: ApiService,
    private activatedRoute: ActivatedRoute,
    ) { 
      this.id = this.activatedRoute.snapshot.paramMap.get('id');
    }


  ngOnInit() {
    this.getVisits();
  }

  getVisits(){
    let url = this.config.getVisits + '&visithistory_master_id=' + this.id
    this.service.get(url)
    .subscribe((res:any)=>{
      this.visits = res.data.visit_history;
      console.log(res)
    })
  }


}
